import { Module } from "vuex";
import { initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const interviewStore: Module<any, any> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default interviewStore;
